import React from 'react';
import { Popup, ScrollView } from 'devextreme-react';
import Fields from './Fields';
import Sortable from 'devextreme-react/sortable';
import './hiddenFieldsPopup.css'

const HiddenFieldsPopup = ({ onClose, visible, hiddenFields, formFields, handleFieldChange, currrentUser, editMode, onTaskDrop }) => {

  return (
    <Popup
      visible={visible}
      onHiding={onClose}
      dragEnabled={true}
      showCloseButton={true}
      title="Hidden Fields"
      width={400}
      height={400}
      shading={false}
    >

      <ScrollView height={300} width="100%">
        <Sortable
          className="sortable-cards"
          group="cardsGroup"
          data={'hiddenGroup'}
          onReorder={onTaskDrop}
          onAdd={onTaskDrop}>
          {hiddenFields.length === 0 ? <div className="empty-placeholder">Drop fields here</div> :
            Array.isArray(hiddenFields) && hiddenFields.map((field, fieldIndex) => (
              <div key={fieldIndex + field.name} className='form-fields'>
                {Fields(field, formFields, handleFieldChange, true, editMode)}
              </div>
            ))
          }


        </Sortable>
      </ScrollView>
    </Popup>
  );
};

export default HiddenFieldsPopup;
